import newrelic from 'newrelic';

export const getRuntimes = () => {
    const isEdgeRuntime = typeof newrelic.noticeError === 'undefined';
    const isNodeRuntime =
        !isEdgeRuntime && (typeof window === 'undefined' || window.navigator.appVersion === 'undefined');

    return { isEdgeRuntime, isNodeRuntime };
};
